import * as React from 'react';

export function Title( ) {

  return(
    <div className = "TOSS fadeIn logoOpacityLayer">
    </div>
  )
}
